<script>
  import { onMount } from 'svelte';
  import { style } from "./toolbox.js";

  export let blocks = [];
  export let components = [];
  export let debug;

  onMount(async () => {
      components = {
          'hero' : (await import('./blocks/Hero.svelte')).default,
          'hero-video' : (await import('./blocks/HeroVideo.svelte')).default,
          'picture-paralax' : (await import('./blocks/PictureParalax.svelte')).default,
          'header' : (await import('./blocks/Header.svelte')).default,
          'footer' : (await import('./blocks/Footer.svelte')).default,
          'about' : (await import('./blocks/About.svelte')).default,
          'our-values' : (await import('./blocks/Values.svelte')).default,
          'counts' : (await import('./blocks/Counts.svelte')).default,
          'features' : (await import('./blocks/Features.svelte')).default,
          'features-tabs' : (await import('./blocks/FeaturesTabs.svelte')).default,
          'features-icons' : (await import('./blocks/FeaturesIcons.svelte')).default,
          'services' : (await import('./blocks/Services.svelte')).default,
          'pricing' : (await import('./blocks/Pricing.svelte')).default,
          'faq' : (await import('./blocks/Faq.svelte')).default,
          'portfolio' : (await import('./blocks/Portfolio.svelte')).default, 
          'testimonials' : (await import('./blocks/Testimonials.svelte')).default,
          'teams' : (await import('./blocks/Teams.svelte')).default,
          'clients' : (await import('./blocks/Clients.svelte')).default,
          'recent-posts' : (await import('./blocks/RecentPosts.svelte')).default,
          'contacts' : (await import('./blocks/Contacts.svelte')).default,
          'headline-with-body' : (await import('./blocks/HeadlineWithBody.svelte')).default,
          'location' : (await import('./blocks/Map.svelte')).default
     };
  });
</script>

<main id="main">
  {#each blocks as block}
  <div id="{block.slug}" style="{style(block, `position: relative`)}">
    {#if debug}
      <div style="position: absolute; background-color: blue; color: white; padding: 5px; left: 0px; top: 50%; z-index: 10000; transform: translateY(-50%); ">
        {block.slug}/{block.name}
      </div>
    {/if}
    {#if block.slug in components}
      <svelte:component on:langChangeNotify this={components[block.slug]} block={block} />
    {:else}
      <div style="color: red; font-weight: bold;">SECTION NOT FOUND!</div>
    {/if}
  </div>
  {/each}

  <script src="assets/js/main.js"></script>
</main>
